import React from "react";

const DeleteTabFiles = ({deleteFilesHandler, tab, text="Delete Selected Files"}) => {
  return (<>
    <button
      className="btn btn-outline-danger mr-2"
      type="button"
      onClick={() => deleteFilesHandler(tab)}>
      {text}
    </button>
  </>)
};
export default DeleteTabFiles;